import {ReactNode} from 'react';

import {Tooltip, Badge} from '@sail/ui';
import {useIntl} from 'react-intl';
import {noTranslateMessages} from '../helpers/noTranslate';
import {getServiceEnvironment} from '../utils/getServiceEnvironment';

const devMessages = noTranslateMessages({
  badgeLabel: {
    id: 'conversations_ui.header.dev_badge_label',
    defaultMessage: 'Dev',
  },
  syntheticsModeLabel: {
    id: 'support_conversations_client.header.dev_badge.synthetics_mode_label',
    defaultMessage: 'Synthetics',
  },
});

function showDevBadge({
  dev = false,
  forestVersion,
  testAgentMode,
}: {
  dev: boolean;
  forestVersion: string;
  testAgentMode: string;
}) {
  const env = getServiceEnvironment();
  if (
    env === 'devbox' ||
    env === 'qa' ||
    env === 'isolated_qa' ||
    forestVersion !== 'off' ||
    testAgentMode !== 'off' ||
    dev
  ) {
    return true;
  }

  return false;
}

function SyntheticBadge() {
  const intl = useIntl();

  return (
    <Badge type="info" data-testid="dev-badge">
      {intl.formatMessage(devMessages.syntheticsModeLabel)}
    </Badge>
  );
}

export function DevBadge({
  dev = false,
  synthetic = false,
  children,
}: {
  dev: boolean;
  synthetic: boolean;
  children?: ReactNode;
}) {
  const intl = useIntl();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const forestVersion = urlSearchParams.get('forestVersion') || 'off';
  const testAgentMode = urlSearchParams.get('test_agent_mode') || 'off';

  if (synthetic) {
    return <SyntheticBadge />;
  }

  if (!showDevBadge({dev, forestVersion, testAgentMode})) {
    return null;
  }

  return (
    <Tooltip
      trigger={
        <Badge type="info" data-testid="dev-badge">
          {intl.formatMessage(devMessages.badgeLabel)}
        </Badge>
      }
    >
      {children}
    </Tooltip>
  );
}
